<template>
  <div class="service-page">
    <div class="head"></div>
    <div class="content">
      <div class="content-name">
        <div>客服姓名</div>
        <div class="content-name-name" v-for="item in contact">{{ item.name }}</div>
      </div>
      <div class="content-name">
        <div>联系方式</div>
        <div class="content-name-name" v-for="item in contact">{{ item.mobile }}</div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "service",

  data() {
    return {
      contact: [{
        name: '客服',
        mobile: '0531-87935508'
      }]
    }
  },
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.service-page {
  padding: 16px 20px 30px;
  background: #FFFFFF;
  border-radius: 8px;

  .head {
    height: 42px;
    background: #F5F7FA;
    border: 1px solid #EDEFF2;
    border-radius: 10px;
  }

  .content {
    display: flex;
    justify-content: space-around;
    margin-top: -30px;

    .content-name {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 14px;
      font-weight: 400;
      color: #262728;

      .content-name-name {
        margin-top: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #262728;
      }
    }
  }
}

</style>